import { OnDestroy, Component } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    template: ``,
    standalone: false
})
export class UnsubscriberComponent implements OnDestroy {
  public subscriptions = new Subscription();

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
